<template>
  <NavigationBarLink
    :collapsed-after-animation="collapsedAfterAnimation"
    :collapsed-navigationbar="collapsedNavigationbar"
    icon="mdi-apps"
    :label="$t('navigationBar.projects')"
    :to="{ name: $routes.Projects }"
  />

  <NavigationBarLink
    v-if="!projects.length && $can('create', 'Project') && $can('access', 'Projects')"
    :collapsed-after-animation="collapsedAfterAnimation"
    :collapsed-navigationbar="collapsedNavigationbar"
    icon="mdi-plus"
    :label="$t('navigationBar.createProject')"
    :to="{ name: $routes.ProjectNew }"
  >
    <template #link="{ to, collapsed, icon, label }">
      <div :class="collapsedAfterAnimation ? 'q-ml-md' : 'q-ml-lg'">
        <rv-button
          data-automation="navigation-bar-projects__collapse"
          :icon="icon"
          :label="collapsed ? '' : label"
          size="md"
          :tertiary="!collapsed"
          :to="to"
          type="a"
        />
      </div>
    </template>
  </NavigationBarLink>

  <template v-if="!loading && $can('access', 'Projects')">
    <q-intersection
      v-for="item in projects"
      :key="item.id"
      class="full-width"
      once
    >
      <NavigationBarProjectItem
        :collapsed-after-animation="collapsedAfterAnimation"
        :collapsed-navigationbar="collapsedNavigationbar"
        :project="item"
      />
    </q-intersection>
  </template>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import type {
  PropType,
} from 'vue'
import {
  onMounted,
  ref,
} from 'vue'
import { useProjectsStore } from '~stores/projectsStore/useProjectsStore'
import { useAlgorithmsStore } from '~stores/useAlgorithmsStore'
import NavigationBarLink from './NavigationBarLink.vue'
import NavigationBarProjectItem from './NavigationBarProjectItem.vue'


defineProps({
  collapsedAfterAnimation: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  collapsedNavigationbar: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
})

const algorithmsStore = useAlgorithmsStore()
const projectsStore = useProjectsStore()
const {
  loadAlgorithms,
  loadAllAlgorithmDefinitions,
} = algorithmsStore
const { isAlgorithmsLoaded } = storeToRefs(algorithmsStore)

const { projects } = storeToRefs(projectsStore)

const loading = ref(false)

onMounted(async () => {
  if (isAlgorithmsLoaded.value) return

  try {
    loading.value = true
    await loadAlgorithms()
    await loadAllAlgorithmDefinitions()
  } catch (e) {
    console.error(e)
  } finally {
    loading.value = false
  }
})
</script>
